import React, { useState, useEffect } from "react";
import "./Products.css";
import "./Header.css";
import axios from "../api/axios";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

import ProductCard from "./ProductCard";

export default function Products({ categorySlug }) {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    let endpoint = '/products';
    if (categorySlug) {
      endpoint = `/products/category/${categorySlug}`;
    }

    axios.get(endpoint)
      .then(response => {
        if (response.data && response.data.data) {
          setProducts(response.data.data);
        } else {
          setProducts([]);
        }
      })
      .catch(error => {
        console.error("Error fetching products:", error);
        setProducts([]);
      });
  }, [categorySlug]);

  return (
    
      <div className="category_outer_main">
        <div className="container-fluid">
          <div className="product_slider">
          <Swiper
            modules={[Navigation, Autoplay]}
           
            slidesPerView={4}
            loop={true}
            autoplay={{ delay: 5000 }}
            navigation
            pagination={{ clickable: true }}

            breakpoints={{
            320: {
              slidesPerView: 2,
             spaceBetween: 5,
            },
            480: {
              slidesPerView: 2,
             spaceBetween: 5,
            },
            768: {
              slidesPerView: 3,
             spaceBetween: 10,
            },
            1024: {
              slidesPerView: 4,
              spaceBetween: 10,
            },
          }}

            >
            { products.map((item) => (
                <SwiperSlide key={item.id}>
                    <ProductCard product = {item} />
                </SwiperSlide>
            ))
            }
            
          </Swiper>
        </div>
        </div>
      </div>
    
  );
}
